import ms from 'ms';
import { useInfiniteQuery } from 'react-query';

import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';

export const useInfiniteItems = ({
  blockId,
  fetchFilters,
  fetchItems,
  initialPage,
  withCursorPagination,
}) => {
  const { topicId } = useTopicContext();

  return useInfiniteQuery(
    [blockId, topicId, fetchFilters],
    ({ pageParam, signal }) =>
      withCursorPagination
        ? fetchItems({
            fetchFilters,
            afterCursor: pageParam,
            signal,
          })
        : fetchItems({ fetchFilters, page: pageParam || initialPage, signal }),
    {
      getNextPageParam: (lastPage, pages) => {
        if (withCursorPagination) {
          return lastPage.hasNextPage ? lastPage.endCursor : undefined;
        }

        if (!lastPage || lastPage.totalItems === 0) {
          return false;
        }
        const items = pages.reduce(
          (acc, value) => [...acc, ...value.items],
          [],
        );

        return items.length < lastPage.totalItems ? pages.length + 1 : false;
      },
      onError: (error) => {
        if (error?.response?.status === 403) {
          displayXhrError(error);
        }
      },
      staleTime: ms('5m'),
      retry: false,
    },
  );
};
